/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NativeLoadingRouteImport } from './routes/native/loading'
import { Route as AuthenticatedVideoRouteImport } from './routes/_authenticated/video'
import { Route as AuthenticatedPurchaseRouteImport } from './routes/_authenticated/purchase'
import { Route as AuthenticatedNewsRouteImport } from './routes/_authenticated/news'
import { Route as AuthenticatedMyPageRouteImport } from './routes/_authenticated/my-page'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'
import { Route as AuthenticatedLaunchCampaignRouteImport } from './routes/_authenticated/launch-campaign'
import { Route as AuthenticatedIncomingRouteImport } from './routes/_authenticated/incoming'
import { Route as AuthenticatedGalleryRouteImport } from './routes/_authenticated/gallery'
import { Route as AuthenticatedExternalLinkRouteImport } from './routes/_authenticated/external-link'
import { Route as AuthenticatedDailyBonusRouteImport } from './routes/_authenticated/daily-bonus'
import { Route as AuthenticatedSettingIndexRouteImport } from './routes/_authenticated/setting/index'
import { Route as AuthenticatedSearchIndexRouteImport } from './routes/_authenticated/search/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedOnboardingIndexRouteImport } from './routes/_authenticated/onboarding/index'
import { Route as AuthenticatedMyPageIndexRouteImport } from './routes/_authenticated/my-page/index'
import { Route as AuthenticatedMessagesIndexRouteImport } from './routes/_authenticated/messages/index'
import { Route as AuthenticatedLiveIndexRouteImport } from './routes/_authenticated/live/index'
import { Route as AuthenticatedFleamarketIndexRouteImport } from './routes/_authenticated/fleamarket/index'
import { Route as AuthenticatedDiscoverIndexRouteImport } from './routes/_authenticated/discover/index'
import { Route as AuthenticatedContactIndexRouteImport } from './routes/_authenticated/contact/index'
import { Route as AuthenticatedBoardIndexRouteImport } from './routes/_authenticated/board/index'
import { Route as AuthenticatedSettingLikesRouteImport } from './routes/_authenticated/setting/likes'
import { Route as AuthenticatedSettingBlockedRouteImport } from './routes/_authenticated/setting/blocked'
import { Route as AuthenticatedSearchResultRouteImport } from './routes/_authenticated/search/result'
import { Route as AuthenticatedProfileUserIdRouteImport } from './routes/_authenticated/profile/$userId'
import { Route as AuthenticatedMyPagePointsHelpRouteImport } from './routes/_authenticated/my-page/points-help'
import { Route as AuthenticatedMyPageFootprintRouteImport } from './routes/_authenticated/my-page/footprint'
import { Route as AuthenticatedMyPageEmailRouteImport } from './routes/_authenticated/my-page/email'
import { Route as AuthenticatedMyPageEditRouteImport } from './routes/_authenticated/my-page/edit'
import { Route as AuthenticatedMyPageBookmarksRouteImport } from './routes/_authenticated/my-page/bookmarks'
import { Route as AuthenticatedMessagesConversationIdRouteImport } from './routes/_authenticated/messages/$conversationId'
import { Route as AuthenticatedLpReviewRouteImport } from './routes/_authenticated/lp/review'
import { Route as AuthenticatedLpLovenseFullcontrolRouteImport } from './routes/_authenticated/lp/lovense-fullcontrol'
import { Route as AuthenticatedCallVideoIndexRouteImport } from './routes/_authenticated/call/video/index'
import { Route as AuthenticatedCallLiveIndexRouteImport } from './routes/_authenticated/call/live/index'
import { Route as AuthenticatedCallAudioIndexRouteImport } from './routes/_authenticated/call/audio/index'
import { Route as AuthenticatedProfileVipBroadcasterUserIdRouteImport } from './routes/_authenticated/profile/vip-broadcaster/$userId'
import { Route as AuthenticatedProfileLiveBroadcasterUserIdRouteImport } from './routes/_authenticated/profile/live-broadcaster/$userId'
import { Route as AuthenticatedFleamarketTransactionTransactionIdRouteImport } from './routes/_authenticated/fleamarket/transaction/$transactionId'
import { Route as AuthenticatedFleamarketSellerSellerIdRouteImport } from './routes/_authenticated/fleamarket/seller/$sellerId'
import { Route as AuthenticatedFleamarketPurchaseConfirmationItemIdRouteImport } from './routes/_authenticated/fleamarket/purchase-confirmation/$itemId'
import { Route as AuthenticatedFleamarketItemItemIdRouteImport } from './routes/_authenticated/fleamarket/item/$itemId'
import { Route as AuthenticatedCallVideoOutgoingRouteImport } from './routes/_authenticated/call/video/outgoing'
import { Route as AuthenticatedCallAudioOutgoingRouteImport } from './routes/_authenticated/call/audio/outgoing'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NativeLoadingRoute = NativeLoadingRouteImport.update({
  id: '/native/loading',
  path: '/native/loading',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedVideoRoute = AuthenticatedVideoRouteImport.update({
  id: '/video',
  path: '/video',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPurchaseRoute = AuthenticatedPurchaseRouteImport.update({
  id: '/purchase',
  path: '/purchase',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNewsRoute = AuthenticatedNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyPageRoute = AuthenticatedMyPageRouteImport.update({
  id: '/my-page',
  path: '/my-page',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLaunchCampaignRoute =
  AuthenticatedLaunchCampaignRouteImport.update({
    id: '/launch-campaign',
    path: '/launch-campaign',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncomingRoute = AuthenticatedIncomingRouteImport.update({
  id: '/incoming',
  path: '/incoming',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGalleryRoute = AuthenticatedGalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExternalLinkRoute =
  AuthenticatedExternalLinkRouteImport.update({
    id: '/external-link',
    path: '/external-link',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDailyBonusRoute = AuthenticatedDailyBonusRouteImport.update({
  id: '/daily-bonus',
  path: '/daily-bonus',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingIndexRoute =
  AuthenticatedSettingIndexRouteImport.update({
    id: '/setting/',
    path: '/setting/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSearchIndexRoute =
  AuthenticatedSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOnboardingIndexRoute =
  AuthenticatedOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyPageIndexRoute =
  AuthenticatedMyPageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMyPageRoute,
  } as any)
const AuthenticatedMessagesIndexRoute =
  AuthenticatedMessagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMessagesRoute,
  } as any)
const AuthenticatedLiveIndexRoute = AuthenticatedLiveIndexRouteImport.update({
  id: '/live/',
  path: '/live/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFleamarketIndexRoute =
  AuthenticatedFleamarketIndexRouteImport.update({
    id: '/fleamarket/',
    path: '/fleamarket/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDiscoverIndexRoute =
  AuthenticatedDiscoverIndexRouteImport.update({
    id: '/discover/',
    path: '/discover/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactIndexRoute =
  AuthenticatedContactIndexRouteImport.update({
    id: '/contact/',
    path: '/contact/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBoardIndexRoute = AuthenticatedBoardIndexRouteImport.update({
  id: '/board/',
  path: '/board/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingLikesRoute =
  AuthenticatedSettingLikesRouteImport.update({
    id: '/setting/likes',
    path: '/setting/likes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingBlockedRoute =
  AuthenticatedSettingBlockedRouteImport.update({
    id: '/setting/blocked',
    path: '/setting/blocked',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSearchResultRoute =
  AuthenticatedSearchResultRouteImport.update({
    id: '/search/result',
    path: '/search/result',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileUserIdRoute =
  AuthenticatedProfileUserIdRouteImport.update({
    id: '/profile/$userId',
    path: '/profile/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyPagePointsHelpRoute =
  AuthenticatedMyPagePointsHelpRouteImport.update({
    id: '/points-help',
    path: '/points-help',
    getParentRoute: () => AuthenticatedMyPageRoute,
  } as any)
const AuthenticatedMyPageFootprintRoute =
  AuthenticatedMyPageFootprintRouteImport.update({
    id: '/footprint',
    path: '/footprint',
    getParentRoute: () => AuthenticatedMyPageRoute,
  } as any)
const AuthenticatedMyPageEmailRoute =
  AuthenticatedMyPageEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => AuthenticatedMyPageRoute,
  } as any)
const AuthenticatedMyPageEditRoute = AuthenticatedMyPageEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AuthenticatedMyPageRoute,
} as any)
const AuthenticatedMyPageBookmarksRoute =
  AuthenticatedMyPageBookmarksRouteImport.update({
    id: '/bookmarks',
    path: '/bookmarks',
    getParentRoute: () => AuthenticatedMyPageRoute,
  } as any)
const AuthenticatedMessagesConversationIdRoute =
  AuthenticatedMessagesConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AuthenticatedMessagesRoute,
  } as any)
const AuthenticatedLpReviewRoute = AuthenticatedLpReviewRouteImport.update({
  id: '/lp/review',
  path: '/lp/review',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLpLovenseFullcontrolRoute =
  AuthenticatedLpLovenseFullcontrolRouteImport.update({
    id: '/lp/lovense-fullcontrol',
    path: '/lp/lovense-fullcontrol',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallVideoIndexRoute =
  AuthenticatedCallVideoIndexRouteImport.update({
    id: '/call/video/',
    path: '/call/video/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallLiveIndexRoute =
  AuthenticatedCallLiveIndexRouteImport.update({
    id: '/call/live/',
    path: '/call/live/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallAudioIndexRoute =
  AuthenticatedCallAudioIndexRouteImport.update({
    id: '/call/audio/',
    path: '/call/audio/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileVipBroadcasterUserIdRoute =
  AuthenticatedProfileVipBroadcasterUserIdRouteImport.update({
    id: '/profile/vip-broadcaster/$userId',
    path: '/profile/vip-broadcaster/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileLiveBroadcasterUserIdRoute =
  AuthenticatedProfileLiveBroadcasterUserIdRouteImport.update({
    id: '/profile/live-broadcaster/$userId',
    path: '/profile/live-broadcaster/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketTransactionTransactionIdRoute =
  AuthenticatedFleamarketTransactionTransactionIdRouteImport.update({
    id: '/fleamarket/transaction/$transactionId',
    path: '/fleamarket/transaction/$transactionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketSellerSellerIdRoute =
  AuthenticatedFleamarketSellerSellerIdRouteImport.update({
    id: '/fleamarket/seller/$sellerId',
    path: '/fleamarket/seller/$sellerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketPurchaseConfirmationItemIdRoute =
  AuthenticatedFleamarketPurchaseConfirmationItemIdRouteImport.update({
    id: '/fleamarket/purchase-confirmation/$itemId',
    path: '/fleamarket/purchase-confirmation/$itemId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketItemItemIdRoute =
  AuthenticatedFleamarketItemItemIdRouteImport.update({
    id: '/fleamarket/item/$itemId',
    path: '/fleamarket/item/$itemId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallVideoOutgoingRoute =
  AuthenticatedCallVideoOutgoingRouteImport.update({
    id: '/call/video/outgoing',
    path: '/call/video/outgoing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallAudioOutgoingRoute =
  AuthenticatedCallAudioOutgoingRouteImport.update({
    id: '/call/audio/outgoing',
    path: '/call/audio/outgoing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/daily-bonus': typeof AuthenticatedDailyBonusRoute
  '/external-link': typeof AuthenticatedExternalLinkRoute
  '/gallery': typeof AuthenticatedGalleryRoute
  '/incoming': typeof AuthenticatedIncomingRoute
  '/launch-campaign': typeof AuthenticatedLaunchCampaignRoute
  '/messages': typeof AuthenticatedMessagesRouteWithChildren
  '/my-page': typeof AuthenticatedMyPageRouteWithChildren
  '/news': typeof AuthenticatedNewsRoute
  '/purchase': typeof AuthenticatedPurchaseRoute
  '/video': typeof AuthenticatedVideoRoute
  '/native/loading': typeof NativeLoadingRoute
  '/lp/lovense-fullcontrol': typeof AuthenticatedLpLovenseFullcontrolRoute
  '/lp/review': typeof AuthenticatedLpReviewRoute
  '/messages/$conversationId': typeof AuthenticatedMessagesConversationIdRoute
  '/my-page/bookmarks': typeof AuthenticatedMyPageBookmarksRoute
  '/my-page/edit': typeof AuthenticatedMyPageEditRoute
  '/my-page/email': typeof AuthenticatedMyPageEmailRoute
  '/my-page/footprint': typeof AuthenticatedMyPageFootprintRoute
  '/my-page/points-help': typeof AuthenticatedMyPagePointsHelpRoute
  '/profile/$userId': typeof AuthenticatedProfileUserIdRoute
  '/search/result': typeof AuthenticatedSearchResultRoute
  '/setting/blocked': typeof AuthenticatedSettingBlockedRoute
  '/setting/likes': typeof AuthenticatedSettingLikesRoute
  '/board/': typeof AuthenticatedBoardIndexRoute
  '/contact/': typeof AuthenticatedContactIndexRoute
  '/discover/': typeof AuthenticatedDiscoverIndexRoute
  '/fleamarket/': typeof AuthenticatedFleamarketIndexRoute
  '/live/': typeof AuthenticatedLiveIndexRoute
  '/messages/': typeof AuthenticatedMessagesIndexRoute
  '/my-page/': typeof AuthenticatedMyPageIndexRoute
  '/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/search/': typeof AuthenticatedSearchIndexRoute
  '/setting/': typeof AuthenticatedSettingIndexRoute
  '/call/audio/outgoing': typeof AuthenticatedCallAudioOutgoingRoute
  '/call/video/outgoing': typeof AuthenticatedCallVideoOutgoingRoute
  '/fleamarket/item/$itemId': typeof AuthenticatedFleamarketItemItemIdRoute
  '/fleamarket/purchase-confirmation/$itemId': typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  '/fleamarket/seller/$sellerId': typeof AuthenticatedFleamarketSellerSellerIdRoute
  '/fleamarket/transaction/$transactionId': typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  '/profile/live-broadcaster/$userId': typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  '/profile/vip-broadcaster/$userId': typeof AuthenticatedProfileVipBroadcasterUserIdRoute
  '/call/audio/': typeof AuthenticatedCallAudioIndexRoute
  '/call/live/': typeof AuthenticatedCallLiveIndexRoute
  '/call/video/': typeof AuthenticatedCallVideoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/daily-bonus': typeof AuthenticatedDailyBonusRoute
  '/external-link': typeof AuthenticatedExternalLinkRoute
  '/gallery': typeof AuthenticatedGalleryRoute
  '/incoming': typeof AuthenticatedIncomingRoute
  '/launch-campaign': typeof AuthenticatedLaunchCampaignRoute
  '/news': typeof AuthenticatedNewsRoute
  '/purchase': typeof AuthenticatedPurchaseRoute
  '/video': typeof AuthenticatedVideoRoute
  '/native/loading': typeof NativeLoadingRoute
  '/lp/lovense-fullcontrol': typeof AuthenticatedLpLovenseFullcontrolRoute
  '/lp/review': typeof AuthenticatedLpReviewRoute
  '/messages/$conversationId': typeof AuthenticatedMessagesConversationIdRoute
  '/my-page/bookmarks': typeof AuthenticatedMyPageBookmarksRoute
  '/my-page/edit': typeof AuthenticatedMyPageEditRoute
  '/my-page/email': typeof AuthenticatedMyPageEmailRoute
  '/my-page/footprint': typeof AuthenticatedMyPageFootprintRoute
  '/my-page/points-help': typeof AuthenticatedMyPagePointsHelpRoute
  '/profile/$userId': typeof AuthenticatedProfileUserIdRoute
  '/search/result': typeof AuthenticatedSearchResultRoute
  '/setting/blocked': typeof AuthenticatedSettingBlockedRoute
  '/setting/likes': typeof AuthenticatedSettingLikesRoute
  '/board': typeof AuthenticatedBoardIndexRoute
  '/contact': typeof AuthenticatedContactIndexRoute
  '/discover': typeof AuthenticatedDiscoverIndexRoute
  '/fleamarket': typeof AuthenticatedFleamarketIndexRoute
  '/live': typeof AuthenticatedLiveIndexRoute
  '/messages': typeof AuthenticatedMessagesIndexRoute
  '/my-page': typeof AuthenticatedMyPageIndexRoute
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/search': typeof AuthenticatedSearchIndexRoute
  '/setting': typeof AuthenticatedSettingIndexRoute
  '/call/audio/outgoing': typeof AuthenticatedCallAudioOutgoingRoute
  '/call/video/outgoing': typeof AuthenticatedCallVideoOutgoingRoute
  '/fleamarket/item/$itemId': typeof AuthenticatedFleamarketItemItemIdRoute
  '/fleamarket/purchase-confirmation/$itemId': typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  '/fleamarket/seller/$sellerId': typeof AuthenticatedFleamarketSellerSellerIdRoute
  '/fleamarket/transaction/$transactionId': typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  '/profile/live-broadcaster/$userId': typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  '/profile/vip-broadcaster/$userId': typeof AuthenticatedProfileVipBroadcasterUserIdRoute
  '/call/audio': typeof AuthenticatedCallAudioIndexRoute
  '/call/live': typeof AuthenticatedCallLiveIndexRoute
  '/call/video': typeof AuthenticatedCallVideoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_authenticated/daily-bonus': typeof AuthenticatedDailyBonusRoute
  '/_authenticated/external-link': typeof AuthenticatedExternalLinkRoute
  '/_authenticated/gallery': typeof AuthenticatedGalleryRoute
  '/_authenticated/incoming': typeof AuthenticatedIncomingRoute
  '/_authenticated/launch-campaign': typeof AuthenticatedLaunchCampaignRoute
  '/_authenticated/messages': typeof AuthenticatedMessagesRouteWithChildren
  '/_authenticated/my-page': typeof AuthenticatedMyPageRouteWithChildren
  '/_authenticated/news': typeof AuthenticatedNewsRoute
  '/_authenticated/purchase': typeof AuthenticatedPurchaseRoute
  '/_authenticated/video': typeof AuthenticatedVideoRoute
  '/native/loading': typeof NativeLoadingRoute
  '/_authenticated/lp/lovense-fullcontrol': typeof AuthenticatedLpLovenseFullcontrolRoute
  '/_authenticated/lp/review': typeof AuthenticatedLpReviewRoute
  '/_authenticated/messages/$conversationId': typeof AuthenticatedMessagesConversationIdRoute
  '/_authenticated/my-page/bookmarks': typeof AuthenticatedMyPageBookmarksRoute
  '/_authenticated/my-page/edit': typeof AuthenticatedMyPageEditRoute
  '/_authenticated/my-page/email': typeof AuthenticatedMyPageEmailRoute
  '/_authenticated/my-page/footprint': typeof AuthenticatedMyPageFootprintRoute
  '/_authenticated/my-page/points-help': typeof AuthenticatedMyPagePointsHelpRoute
  '/_authenticated/profile/$userId': typeof AuthenticatedProfileUserIdRoute
  '/_authenticated/search/result': typeof AuthenticatedSearchResultRoute
  '/_authenticated/setting/blocked': typeof AuthenticatedSettingBlockedRoute
  '/_authenticated/setting/likes': typeof AuthenticatedSettingLikesRoute
  '/_authenticated/board/': typeof AuthenticatedBoardIndexRoute
  '/_authenticated/contact/': typeof AuthenticatedContactIndexRoute
  '/_authenticated/discover/': typeof AuthenticatedDiscoverIndexRoute
  '/_authenticated/fleamarket/': typeof AuthenticatedFleamarketIndexRoute
  '/_authenticated/live/': typeof AuthenticatedLiveIndexRoute
  '/_authenticated/messages/': typeof AuthenticatedMessagesIndexRoute
  '/_authenticated/my-page/': typeof AuthenticatedMyPageIndexRoute
  '/_authenticated/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/search/': typeof AuthenticatedSearchIndexRoute
  '/_authenticated/setting/': typeof AuthenticatedSettingIndexRoute
  '/_authenticated/call/audio/outgoing': typeof AuthenticatedCallAudioOutgoingRoute
  '/_authenticated/call/video/outgoing': typeof AuthenticatedCallVideoOutgoingRoute
  '/_authenticated/fleamarket/item/$itemId': typeof AuthenticatedFleamarketItemItemIdRoute
  '/_authenticated/fleamarket/purchase-confirmation/$itemId': typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  '/_authenticated/fleamarket/seller/$sellerId': typeof AuthenticatedFleamarketSellerSellerIdRoute
  '/_authenticated/fleamarket/transaction/$transactionId': typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  '/_authenticated/profile/live-broadcaster/$userId': typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  '/_authenticated/profile/vip-broadcaster/$userId': typeof AuthenticatedProfileVipBroadcasterUserIdRoute
  '/_authenticated/call/audio/': typeof AuthenticatedCallAudioIndexRoute
  '/_authenticated/call/live/': typeof AuthenticatedCallLiveIndexRoute
  '/_authenticated/call/video/': typeof AuthenticatedCallVideoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/signup'
    | '/daily-bonus'
    | '/external-link'
    | '/gallery'
    | '/incoming'
    | '/launch-campaign'
    | '/messages'
    | '/my-page'
    | '/news'
    | '/purchase'
    | '/video'
    | '/native/loading'
    | '/lp/lovense-fullcontrol'
    | '/lp/review'
    | '/messages/$conversationId'
    | '/my-page/bookmarks'
    | '/my-page/edit'
    | '/my-page/email'
    | '/my-page/footprint'
    | '/my-page/points-help'
    | '/profile/$userId'
    | '/search/result'
    | '/setting/blocked'
    | '/setting/likes'
    | '/board/'
    | '/contact/'
    | '/discover/'
    | '/fleamarket/'
    | '/live/'
    | '/messages/'
    | '/my-page/'
    | '/onboarding/'
    | '/profile/'
    | '/search/'
    | '/setting/'
    | '/call/audio/outgoing'
    | '/call/video/outgoing'
    | '/fleamarket/item/$itemId'
    | '/fleamarket/purchase-confirmation/$itemId'
    | '/fleamarket/seller/$sellerId'
    | '/fleamarket/transaction/$transactionId'
    | '/profile/live-broadcaster/$userId'
    | '/profile/vip-broadcaster/$userId'
    | '/call/audio/'
    | '/call/live/'
    | '/call/video/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/signup'
    | '/daily-bonus'
    | '/external-link'
    | '/gallery'
    | '/incoming'
    | '/launch-campaign'
    | '/news'
    | '/purchase'
    | '/video'
    | '/native/loading'
    | '/lp/lovense-fullcontrol'
    | '/lp/review'
    | '/messages/$conversationId'
    | '/my-page/bookmarks'
    | '/my-page/edit'
    | '/my-page/email'
    | '/my-page/footprint'
    | '/my-page/points-help'
    | '/profile/$userId'
    | '/search/result'
    | '/setting/blocked'
    | '/setting/likes'
    | '/board'
    | '/contact'
    | '/discover'
    | '/fleamarket'
    | '/live'
    | '/messages'
    | '/my-page'
    | '/onboarding'
    | '/profile'
    | '/search'
    | '/setting'
    | '/call/audio/outgoing'
    | '/call/video/outgoing'
    | '/fleamarket/item/$itemId'
    | '/fleamarket/purchase-confirmation/$itemId'
    | '/fleamarket/seller/$sellerId'
    | '/fleamarket/transaction/$transactionId'
    | '/profile/live-broadcaster/$userId'
    | '/profile/vip-broadcaster/$userId'
    | '/call/audio'
    | '/call/live'
    | '/call/video'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/signup'
    | '/_authenticated/daily-bonus'
    | '/_authenticated/external-link'
    | '/_authenticated/gallery'
    | '/_authenticated/incoming'
    | '/_authenticated/launch-campaign'
    | '/_authenticated/messages'
    | '/_authenticated/my-page'
    | '/_authenticated/news'
    | '/_authenticated/purchase'
    | '/_authenticated/video'
    | '/native/loading'
    | '/_authenticated/lp/lovense-fullcontrol'
    | '/_authenticated/lp/review'
    | '/_authenticated/messages/$conversationId'
    | '/_authenticated/my-page/bookmarks'
    | '/_authenticated/my-page/edit'
    | '/_authenticated/my-page/email'
    | '/_authenticated/my-page/footprint'
    | '/_authenticated/my-page/points-help'
    | '/_authenticated/profile/$userId'
    | '/_authenticated/search/result'
    | '/_authenticated/setting/blocked'
    | '/_authenticated/setting/likes'
    | '/_authenticated/board/'
    | '/_authenticated/contact/'
    | '/_authenticated/discover/'
    | '/_authenticated/fleamarket/'
    | '/_authenticated/live/'
    | '/_authenticated/messages/'
    | '/_authenticated/my-page/'
    | '/_authenticated/onboarding/'
    | '/_authenticated/profile/'
    | '/_authenticated/search/'
    | '/_authenticated/setting/'
    | '/_authenticated/call/audio/outgoing'
    | '/_authenticated/call/video/outgoing'
    | '/_authenticated/fleamarket/item/$itemId'
    | '/_authenticated/fleamarket/purchase-confirmation/$itemId'
    | '/_authenticated/fleamarket/seller/$sellerId'
    | '/_authenticated/fleamarket/transaction/$transactionId'
    | '/_authenticated/profile/live-broadcaster/$userId'
    | '/_authenticated/profile/vip-broadcaster/$userId'
    | '/_authenticated/call/audio/'
    | '/_authenticated/call/live/'
    | '/_authenticated/call/video/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  NativeLoadingRoute: typeof NativeLoadingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/native/loading': {
      id: '/native/loading'
      path: '/native/loading'
      fullPath: '/native/loading'
      preLoaderRoute: typeof NativeLoadingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/video': {
      id: '/_authenticated/video'
      path: '/video'
      fullPath: '/video'
      preLoaderRoute: typeof AuthenticatedVideoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchase': {
      id: '/_authenticated/purchase'
      path: '/purchase'
      fullPath: '/purchase'
      preLoaderRoute: typeof AuthenticatedPurchaseRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/news': {
      id: '/_authenticated/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof AuthenticatedNewsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-page': {
      id: '/_authenticated/my-page'
      path: '/my-page'
      fullPath: '/my-page'
      preLoaderRoute: typeof AuthenticatedMyPageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages': {
      id: '/_authenticated/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthenticatedMessagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/launch-campaign': {
      id: '/_authenticated/launch-campaign'
      path: '/launch-campaign'
      fullPath: '/launch-campaign'
      preLoaderRoute: typeof AuthenticatedLaunchCampaignRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incoming': {
      id: '/_authenticated/incoming'
      path: '/incoming'
      fullPath: '/incoming'
      preLoaderRoute: typeof AuthenticatedIncomingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/gallery': {
      id: '/_authenticated/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof AuthenticatedGalleryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/external-link': {
      id: '/_authenticated/external-link'
      path: '/external-link'
      fullPath: '/external-link'
      preLoaderRoute: typeof AuthenticatedExternalLinkRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/daily-bonus': {
      id: '/_authenticated/daily-bonus'
      path: '/daily-bonus'
      fullPath: '/daily-bonus'
      preLoaderRoute: typeof AuthenticatedDailyBonusRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setting/': {
      id: '/_authenticated/setting/'
      path: '/setting'
      fullPath: '/setting/'
      preLoaderRoute: typeof AuthenticatedSettingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search/': {
      id: '/_authenticated/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AuthenticatedSearchIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding/': {
      id: '/_authenticated/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthenticatedOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-page/': {
      id: '/_authenticated/my-page/'
      path: '/'
      fullPath: '/my-page/'
      preLoaderRoute: typeof AuthenticatedMyPageIndexRouteImport
      parentRoute: typeof AuthenticatedMyPageRoute
    }
    '/_authenticated/messages/': {
      id: '/_authenticated/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof AuthenticatedMessagesIndexRouteImport
      parentRoute: typeof AuthenticatedMessagesRoute
    }
    '/_authenticated/live/': {
      id: '/_authenticated/live/'
      path: '/live'
      fullPath: '/live/'
      preLoaderRoute: typeof AuthenticatedLiveIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/': {
      id: '/_authenticated/fleamarket/'
      path: '/fleamarket'
      fullPath: '/fleamarket/'
      preLoaderRoute: typeof AuthenticatedFleamarketIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/discover/': {
      id: '/_authenticated/discover/'
      path: '/discover'
      fullPath: '/discover/'
      preLoaderRoute: typeof AuthenticatedDiscoverIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contact/': {
      id: '/_authenticated/contact/'
      path: '/contact'
      fullPath: '/contact/'
      preLoaderRoute: typeof AuthenticatedContactIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/board/': {
      id: '/_authenticated/board/'
      path: '/board'
      fullPath: '/board/'
      preLoaderRoute: typeof AuthenticatedBoardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setting/likes': {
      id: '/_authenticated/setting/likes'
      path: '/setting/likes'
      fullPath: '/setting/likes'
      preLoaderRoute: typeof AuthenticatedSettingLikesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setting/blocked': {
      id: '/_authenticated/setting/blocked'
      path: '/setting/blocked'
      fullPath: '/setting/blocked'
      preLoaderRoute: typeof AuthenticatedSettingBlockedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search/result': {
      id: '/_authenticated/search/result'
      path: '/search/result'
      fullPath: '/search/result'
      preLoaderRoute: typeof AuthenticatedSearchResultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/$userId': {
      id: '/_authenticated/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/profile/$userId'
      preLoaderRoute: typeof AuthenticatedProfileUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-page/points-help': {
      id: '/_authenticated/my-page/points-help'
      path: '/points-help'
      fullPath: '/my-page/points-help'
      preLoaderRoute: typeof AuthenticatedMyPagePointsHelpRouteImport
      parentRoute: typeof AuthenticatedMyPageRoute
    }
    '/_authenticated/my-page/footprint': {
      id: '/_authenticated/my-page/footprint'
      path: '/footprint'
      fullPath: '/my-page/footprint'
      preLoaderRoute: typeof AuthenticatedMyPageFootprintRouteImport
      parentRoute: typeof AuthenticatedMyPageRoute
    }
    '/_authenticated/my-page/email': {
      id: '/_authenticated/my-page/email'
      path: '/email'
      fullPath: '/my-page/email'
      preLoaderRoute: typeof AuthenticatedMyPageEmailRouteImport
      parentRoute: typeof AuthenticatedMyPageRoute
    }
    '/_authenticated/my-page/edit': {
      id: '/_authenticated/my-page/edit'
      path: '/edit'
      fullPath: '/my-page/edit'
      preLoaderRoute: typeof AuthenticatedMyPageEditRouteImport
      parentRoute: typeof AuthenticatedMyPageRoute
    }
    '/_authenticated/my-page/bookmarks': {
      id: '/_authenticated/my-page/bookmarks'
      path: '/bookmarks'
      fullPath: '/my-page/bookmarks'
      preLoaderRoute: typeof AuthenticatedMyPageBookmarksRouteImport
      parentRoute: typeof AuthenticatedMyPageRoute
    }
    '/_authenticated/messages/$conversationId': {
      id: '/_authenticated/messages/$conversationId'
      path: '/$conversationId'
      fullPath: '/messages/$conversationId'
      preLoaderRoute: typeof AuthenticatedMessagesConversationIdRouteImport
      parentRoute: typeof AuthenticatedMessagesRoute
    }
    '/_authenticated/lp/review': {
      id: '/_authenticated/lp/review'
      path: '/lp/review'
      fullPath: '/lp/review'
      preLoaderRoute: typeof AuthenticatedLpReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/lp/lovense-fullcontrol': {
      id: '/_authenticated/lp/lovense-fullcontrol'
      path: '/lp/lovense-fullcontrol'
      fullPath: '/lp/lovense-fullcontrol'
      preLoaderRoute: typeof AuthenticatedLpLovenseFullcontrolRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/video/': {
      id: '/_authenticated/call/video/'
      path: '/call/video'
      fullPath: '/call/video/'
      preLoaderRoute: typeof AuthenticatedCallVideoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/live/': {
      id: '/_authenticated/call/live/'
      path: '/call/live'
      fullPath: '/call/live/'
      preLoaderRoute: typeof AuthenticatedCallLiveIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/audio/': {
      id: '/_authenticated/call/audio/'
      path: '/call/audio'
      fullPath: '/call/audio/'
      preLoaderRoute: typeof AuthenticatedCallAudioIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/vip-broadcaster/$userId': {
      id: '/_authenticated/profile/vip-broadcaster/$userId'
      path: '/profile/vip-broadcaster/$userId'
      fullPath: '/profile/vip-broadcaster/$userId'
      preLoaderRoute: typeof AuthenticatedProfileVipBroadcasterUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/live-broadcaster/$userId': {
      id: '/_authenticated/profile/live-broadcaster/$userId'
      path: '/profile/live-broadcaster/$userId'
      fullPath: '/profile/live-broadcaster/$userId'
      preLoaderRoute: typeof AuthenticatedProfileLiveBroadcasterUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/transaction/$transactionId': {
      id: '/_authenticated/fleamarket/transaction/$transactionId'
      path: '/fleamarket/transaction/$transactionId'
      fullPath: '/fleamarket/transaction/$transactionId'
      preLoaderRoute: typeof AuthenticatedFleamarketTransactionTransactionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/seller/$sellerId': {
      id: '/_authenticated/fleamarket/seller/$sellerId'
      path: '/fleamarket/seller/$sellerId'
      fullPath: '/fleamarket/seller/$sellerId'
      preLoaderRoute: typeof AuthenticatedFleamarketSellerSellerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/purchase-confirmation/$itemId': {
      id: '/_authenticated/fleamarket/purchase-confirmation/$itemId'
      path: '/fleamarket/purchase-confirmation/$itemId'
      fullPath: '/fleamarket/purchase-confirmation/$itemId'
      preLoaderRoute: typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/item/$itemId': {
      id: '/_authenticated/fleamarket/item/$itemId'
      path: '/fleamarket/item/$itemId'
      fullPath: '/fleamarket/item/$itemId'
      preLoaderRoute: typeof AuthenticatedFleamarketItemItemIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/video/outgoing': {
      id: '/_authenticated/call/video/outgoing'
      path: '/call/video/outgoing'
      fullPath: '/call/video/outgoing'
      preLoaderRoute: typeof AuthenticatedCallVideoOutgoingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/audio/outgoing': {
      id: '/_authenticated/call/audio/outgoing'
      path: '/call/audio/outgoing'
      fullPath: '/call/audio/outgoing'
      preLoaderRoute: typeof AuthenticatedCallAudioOutgoingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedMessagesRouteChildren {
  AuthenticatedMessagesConversationIdRoute: typeof AuthenticatedMessagesConversationIdRoute
  AuthenticatedMessagesIndexRoute: typeof AuthenticatedMessagesIndexRoute
}

const AuthenticatedMessagesRouteChildren: AuthenticatedMessagesRouteChildren = {
  AuthenticatedMessagesConversationIdRoute:
    AuthenticatedMessagesConversationIdRoute,
  AuthenticatedMessagesIndexRoute: AuthenticatedMessagesIndexRoute,
}

const AuthenticatedMessagesRouteWithChildren =
  AuthenticatedMessagesRoute._addFileChildren(
    AuthenticatedMessagesRouteChildren,
  )

interface AuthenticatedMyPageRouteChildren {
  AuthenticatedMyPageBookmarksRoute: typeof AuthenticatedMyPageBookmarksRoute
  AuthenticatedMyPageEditRoute: typeof AuthenticatedMyPageEditRoute
  AuthenticatedMyPageEmailRoute: typeof AuthenticatedMyPageEmailRoute
  AuthenticatedMyPageFootprintRoute: typeof AuthenticatedMyPageFootprintRoute
  AuthenticatedMyPagePointsHelpRoute: typeof AuthenticatedMyPagePointsHelpRoute
  AuthenticatedMyPageIndexRoute: typeof AuthenticatedMyPageIndexRoute
}

const AuthenticatedMyPageRouteChildren: AuthenticatedMyPageRouteChildren = {
  AuthenticatedMyPageBookmarksRoute: AuthenticatedMyPageBookmarksRoute,
  AuthenticatedMyPageEditRoute: AuthenticatedMyPageEditRoute,
  AuthenticatedMyPageEmailRoute: AuthenticatedMyPageEmailRoute,
  AuthenticatedMyPageFootprintRoute: AuthenticatedMyPageFootprintRoute,
  AuthenticatedMyPagePointsHelpRoute: AuthenticatedMyPagePointsHelpRoute,
  AuthenticatedMyPageIndexRoute: AuthenticatedMyPageIndexRoute,
}

const AuthenticatedMyPageRouteWithChildren =
  AuthenticatedMyPageRoute._addFileChildren(AuthenticatedMyPageRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedDailyBonusRoute: typeof AuthenticatedDailyBonusRoute
  AuthenticatedExternalLinkRoute: typeof AuthenticatedExternalLinkRoute
  AuthenticatedGalleryRoute: typeof AuthenticatedGalleryRoute
  AuthenticatedIncomingRoute: typeof AuthenticatedIncomingRoute
  AuthenticatedLaunchCampaignRoute: typeof AuthenticatedLaunchCampaignRoute
  AuthenticatedMessagesRoute: typeof AuthenticatedMessagesRouteWithChildren
  AuthenticatedMyPageRoute: typeof AuthenticatedMyPageRouteWithChildren
  AuthenticatedNewsRoute: typeof AuthenticatedNewsRoute
  AuthenticatedPurchaseRoute: typeof AuthenticatedPurchaseRoute
  AuthenticatedVideoRoute: typeof AuthenticatedVideoRoute
  AuthenticatedLpLovenseFullcontrolRoute: typeof AuthenticatedLpLovenseFullcontrolRoute
  AuthenticatedLpReviewRoute: typeof AuthenticatedLpReviewRoute
  AuthenticatedProfileUserIdRoute: typeof AuthenticatedProfileUserIdRoute
  AuthenticatedSearchResultRoute: typeof AuthenticatedSearchResultRoute
  AuthenticatedSettingBlockedRoute: typeof AuthenticatedSettingBlockedRoute
  AuthenticatedSettingLikesRoute: typeof AuthenticatedSettingLikesRoute
  AuthenticatedBoardIndexRoute: typeof AuthenticatedBoardIndexRoute
  AuthenticatedContactIndexRoute: typeof AuthenticatedContactIndexRoute
  AuthenticatedDiscoverIndexRoute: typeof AuthenticatedDiscoverIndexRoute
  AuthenticatedFleamarketIndexRoute: typeof AuthenticatedFleamarketIndexRoute
  AuthenticatedLiveIndexRoute: typeof AuthenticatedLiveIndexRoute
  AuthenticatedOnboardingIndexRoute: typeof AuthenticatedOnboardingIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedSearchIndexRoute: typeof AuthenticatedSearchIndexRoute
  AuthenticatedSettingIndexRoute: typeof AuthenticatedSettingIndexRoute
  AuthenticatedCallAudioOutgoingRoute: typeof AuthenticatedCallAudioOutgoingRoute
  AuthenticatedCallVideoOutgoingRoute: typeof AuthenticatedCallVideoOutgoingRoute
  AuthenticatedFleamarketItemItemIdRoute: typeof AuthenticatedFleamarketItemItemIdRoute
  AuthenticatedFleamarketPurchaseConfirmationItemIdRoute: typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  AuthenticatedFleamarketSellerSellerIdRoute: typeof AuthenticatedFleamarketSellerSellerIdRoute
  AuthenticatedFleamarketTransactionTransactionIdRoute: typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  AuthenticatedProfileLiveBroadcasterUserIdRoute: typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  AuthenticatedProfileVipBroadcasterUserIdRoute: typeof AuthenticatedProfileVipBroadcasterUserIdRoute
  AuthenticatedCallAudioIndexRoute: typeof AuthenticatedCallAudioIndexRoute
  AuthenticatedCallLiveIndexRoute: typeof AuthenticatedCallLiveIndexRoute
  AuthenticatedCallVideoIndexRoute: typeof AuthenticatedCallVideoIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDailyBonusRoute: AuthenticatedDailyBonusRoute,
  AuthenticatedExternalLinkRoute: AuthenticatedExternalLinkRoute,
  AuthenticatedGalleryRoute: AuthenticatedGalleryRoute,
  AuthenticatedIncomingRoute: AuthenticatedIncomingRoute,
  AuthenticatedLaunchCampaignRoute: AuthenticatedLaunchCampaignRoute,
  AuthenticatedMessagesRoute: AuthenticatedMessagesRouteWithChildren,
  AuthenticatedMyPageRoute: AuthenticatedMyPageRouteWithChildren,
  AuthenticatedNewsRoute: AuthenticatedNewsRoute,
  AuthenticatedPurchaseRoute: AuthenticatedPurchaseRoute,
  AuthenticatedVideoRoute: AuthenticatedVideoRoute,
  AuthenticatedLpLovenseFullcontrolRoute:
    AuthenticatedLpLovenseFullcontrolRoute,
  AuthenticatedLpReviewRoute: AuthenticatedLpReviewRoute,
  AuthenticatedProfileUserIdRoute: AuthenticatedProfileUserIdRoute,
  AuthenticatedSearchResultRoute: AuthenticatedSearchResultRoute,
  AuthenticatedSettingBlockedRoute: AuthenticatedSettingBlockedRoute,
  AuthenticatedSettingLikesRoute: AuthenticatedSettingLikesRoute,
  AuthenticatedBoardIndexRoute: AuthenticatedBoardIndexRoute,
  AuthenticatedContactIndexRoute: AuthenticatedContactIndexRoute,
  AuthenticatedDiscoverIndexRoute: AuthenticatedDiscoverIndexRoute,
  AuthenticatedFleamarketIndexRoute: AuthenticatedFleamarketIndexRoute,
  AuthenticatedLiveIndexRoute: AuthenticatedLiveIndexRoute,
  AuthenticatedOnboardingIndexRoute: AuthenticatedOnboardingIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedSearchIndexRoute: AuthenticatedSearchIndexRoute,
  AuthenticatedSettingIndexRoute: AuthenticatedSettingIndexRoute,
  AuthenticatedCallAudioOutgoingRoute: AuthenticatedCallAudioOutgoingRoute,
  AuthenticatedCallVideoOutgoingRoute: AuthenticatedCallVideoOutgoingRoute,
  AuthenticatedFleamarketItemItemIdRoute:
    AuthenticatedFleamarketItemItemIdRoute,
  AuthenticatedFleamarketPurchaseConfirmationItemIdRoute:
    AuthenticatedFleamarketPurchaseConfirmationItemIdRoute,
  AuthenticatedFleamarketSellerSellerIdRoute:
    AuthenticatedFleamarketSellerSellerIdRoute,
  AuthenticatedFleamarketTransactionTransactionIdRoute:
    AuthenticatedFleamarketTransactionTransactionIdRoute,
  AuthenticatedProfileLiveBroadcasterUserIdRoute:
    AuthenticatedProfileLiveBroadcasterUserIdRoute,
  AuthenticatedProfileVipBroadcasterUserIdRoute:
    AuthenticatedProfileVipBroadcasterUserIdRoute,
  AuthenticatedCallAudioIndexRoute: AuthenticatedCallAudioIndexRoute,
  AuthenticatedCallLiveIndexRoute: AuthenticatedCallLiveIndexRoute,
  AuthenticatedCallVideoIndexRoute: AuthenticatedCallVideoIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  NativeLoadingRoute: NativeLoadingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
